/**
 * The signed-in page frame: skip link, header, nav, main.
 *
 * The skip link is the first focusable thing on the page so a keyboard or
 * screen-reader user can jump past the navigation to the content instead of
 * tabbing through it on every page (Decision #18).
 */
import { useAuth } from '../auth/useAuth.js';
import Nav from './Nav.jsx';

export function AppShell({ children }) {
  const { profile, user, signOut } = useAuth();

  return (
    <div className="shell">
      <a className="skip-link" href="#main">
        Skip to main content
      </a>

      <header className="shell__header">
        <div className="shell__brand">
          <span className="shell__logo" aria-hidden="true">
            ✓
          </span>
          <span>
            <strong>Attest</strong> <span className="muted">Admin</span>
          </span>
        </div>

        <div className="shell__account">
          <span className="shell__who">
            {profile?.fullName ?? user?.email}
            {profile?.institution && (
              <span className="muted"> · {profile.institution.shortName.toUpperCase()}</span>
            )}
          </span>
          <button type="button" className="btn btn--quiet" onClick={signOut}>
            Sign out
          </button>
        </div>
      </header>

      <div className="shell__body">
        <aside className="shell__sidebar">
          <Nav />
        </aside>

        <main id="main" className="shell__main" tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default AppShell;
